<template>
  <content-items-view
    content-type="trial-reports"
    content-type-singular="trial-report"
    content-name="Trial Reports"
    content-name-singular="Trial Report"
  />
</template>

<script>
import ContentItemsView from '@/views/content-item/content-items-view/ContentItemsView.vue'
import ContentItemsList from '@/views/content-item/content-items-list/ContentItemsList.vue'

export default {
  components: {
    ContentItemsList,
    ContentItemsView,
  },
}
</script>

<style scoped>

</style>
